/**
 * PRODUCT RANDOMISER JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Product Randomiser UI, data
         * UI interaction functions
         */
        console.log( 'Product Randomiser widget - init' );
        
        
        
        // Get total items in each list...
        var one_total = $( '.product_randomiser .one li' ).length - 1;
        //console.log(( 'one_total: ' + one_total );
        var two_total = $( '.product_randomiser .two li' ).length - 1;
        //console.log(( 'two_total: ' + two_total );
        var three_total = $( '.product_randomiser .three li' ).length - 1;
        //console.log(( 'occasion_total: ' + occasion_total );
        
        
        // Set slot lists to the 'list_top_offset' so the initial '?'s show at first...
        this.setSlotHeight();
        
        // Add 'last' class to the last LI in each list...
        function addLastClasses() {
            $( '.product_randomiser .one li' ).last().addClass( 'last' );
            $( '.product_randomiser .two li' ).last().addClass( 'last' );
            $( '.product_randomiser .three li' ).last().addClass( 'last' );
        }
        
        // Loop over each LI and set TOP position, offset by the accumulative heights of each...
        function setSlotItemPositions() {
            $( '.product_randomiser ul' ).each( function() {
                var i = 0;
                $( this ).find( 'li' ).each( function() {
                    var $this = $( this );
                    $this.css( 'top' , i );
                    i += $this.outerHeight( true );
                });
            });
        }
             
        // Scroll Slots...
        function scrollSlots( item ) {
            var top = parseInt( item.css( 'top' ) );
            if ( top < -70 ) { //bit arbitrary!
                var lastitem = item.closest( 'ul' ).find( '.last' );
                lastitem.removeClass( 'last' );
                item.addClass( 'last' );
                var top = ( parseInt( lastitem.css( 'top' ) ) + ( lastitem.outerHeight( true ) ) );
                item.css( 'top' , top );
            }
            item.animate({
                top: ( parseInt( top ) - 70 )
            }, 50, 'linear', function() {
                scrollSlots( $( this ) )
            });
        }
        
        function randomIntFromInterval( min, max ) {
            //console.log(( 'min: ' + min + ' max: ' + max );
            return Math.floor( Math.random() * max ) + min;
        }
        
        var selected_one = 0;
        function pickOne() {
            selected_one = randomIntFromInterval( 1, one_total );
            //console.log(( 'selected_place: ' + selected_place );
            $( '.product_randomiser .one ul li' ).stop();
            $( '.product_randomiser .one ul li' ).css( 'opacity', 0 ).removeClass( 'last' );
            $( '.product_randomiser .one ul li:nth-child(' + selected_one + ')' ).css( 'top', 0 ).css( 'opacity', 1 );
        }
        
        var selected_two = 0;
        function pickTwo() {
            selected_two = randomIntFromInterval( 1, two_total );
            //console.log(( 'selected_colour: ' + selected_colour );
            $( '.product_randomiser .two ul li' ).stop();
            $( '.product_randomiser .two ul li' ).css( 'opacity', 0 ).removeClass( 'last' );
            $( '.product_randomiser .two ul li:nth-child(' + selected_two + ')' ).css( 'top', 0 ).css( 'opacity', 1 );
        }
        
        var selected_three = 0;
        function pickThree() {
            selected_three = randomIntFromInterval( 1, three_total );
            //console.log(( 'selected_occasion: ' + selected_occasion );
            $( '.product_randomiser .three ul li' ).stop();
            $( '.product_randomiser .three ul li' ).css( 'opacity', 0 ).removeClass( 'last' );
            $( '.product_randomiser .three ul li:nth-child(' + selected_three + ')' ).css( 'top', 0 ).css( 'opacity', 1 );
            $( '.product_randomiser a' ).removeClass( 'disabled' );
            addLastClasses();
        }
        

        // Click on Randomise button...
        $( 'body' ).on( 'click', '.product_randomiser a:not(.disabled)', function( event ) {
            setSlotItemPositions();
            
            $( this ).addClass( 'disabled' );
            
            // Remove initial list items
            $( '.question_mark' ).remove();
            $( '.default' ).remove();
            
            $( '.product_randomiser ul li' ).css( 'opacity', '1' );
            
            var countOneScrolls = $( '.product_randomiser .one ul li' ).length;
            //console.log(( countPlaceScrolls );
            
            for ( var i=0; i < countOneScrolls; i++ ) {
               scrollSlots( $( '.product_randomiser .one ul li:nth-child(' + i + ')' ) );
            }
            
            var countTwoScrolls = $( '.product_randomiser .two ul li' ).length;
            //console.log(( countColourScrolls );
            
            for ( var i=0; i < countTwoScrolls; i++ ) {
               scrollSlots( $( '.product_randomiser .two ul li:nth-child(' + i + ')' ) );
            }
            
            var countThreeScrolls = $( '.product_randomiser .three ul li' ).length;
            //console.log(( countOccasionScrolls );
            
            for ( var i=0; i < countThreeScrolls; i++ ) {
               scrollSlots( $( '.product_randomiser .three ul li:nth-child(' + i + ')' ) );
            }
            
            // Get random numbers...
            var one_timer = setTimeout( pickOne, 2000 );
            var two_timer = setTimeout( pickTwo, 3000 );
            var three_timer = setTimeout( pickThree, 4000 );

            //console.log(( 'selected_place: ' + selected_place );
            //console.log(( 'selected_colour: ' + selected_colour );
            //console.log(( 'selected_occasion: ' + selected_occasion );
            
            event.preventDefault();
        });


    },
    
    setSlotHeight() {
        $( window ).resize(function() {
            resizeSlots();
        });
        
        function resizeSlots() {
            if ( $(window).width() < 375 ) {
                var list_top_offset = ( $( '.slot' ).height() / 3.5 ) - 10;

            } else if ( $(window).width() < 500 ) {
                var list_top_offset = ( $( '.slot' ).height() / 3.5 ) - 5;

            } else if ( $(window).width() < 769 ) {
                var list_top_offset = ( $( '.slot' ).height() / 3.5 ) + 5;

            } else if ( $(window).width() < 900 ) {
                var list_top_offset = ( $( '.slot' ).height() / 3.5 ) + 15;

            } else {
                var list_top_offset = ( $( '.slot' ).height() / 3 ) - 5;
            }
            //console.log(( 'slot: ' + $( '.slot' ).height() );
            //console.log(( 'list_top_offset: ' + list_top_offset );
            $( '.product_randomiser ul' ).css( 'top', list_top_offset );
        }
        resizeSlots();
    }

}